import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './Tooltip.css';

// Created Tooltip comp to show full text in tooltip when user hover on truncated text or ellipses
export const TootipComp =({ text }) => {
  const textRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsOverflowed(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  return (
    <span className='ml-10 text-truncate' ref={textRef}>
      {text}
      {isOverflowed && (
        <span className='tooltiptext'>{text}</span>
      )}
    </span>
  );
};

TootipComp.propTypes = {
  text: PropTypes.string
};
